import Notes from "./components/Notes";

export default Notes;
